import React, { useEffect, useState } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { auth, firestore, storage } from '../../firebase/firebaseConfig';
import { Button, Input, message, Modal, Popconfirm, Select, Space } from 'antd';
import { collection, doc, onSnapshot, runTransaction, setDoc } from '@firebase/firestore';
import "./Admin.css"
import { getDownloadURL, ref, uploadBytes } from 'firebase/storage';
import emailjs from '@emailjs/browser';
import dayjs from 'dayjs';
import axios from 'axios';

function Admin() {
    const [messageApi, contextHolder] = message.useMessage();
    const [object, setObject] = useState({});
    const [allAdmin, setAllAdmin] = useState([]);
    const [open, setOpen] = useState(false);
    const [details, setDetails] = useState(false);
    const [selectedIndex, setSelectedIndex] = useState("");
    const [invoiceNumber, setInvoiceNumber] = useState("");
    const [invoiceNumberNoGst, setInvoiceNumberNoGst] = useState("");

    async function onload() {
        messageApi.loading("Loading all the users...", 0);

        onSnapshot(doc(firestore, "global", "counter"), snapshot => {
            const data = snapshot.data();
            setInvoiceNumber(data?.invoice_count ?? 0);
            setInvoiceNumberNoGst(data?.invoice_count_nogst ?? 0);
        })

        onSnapshot(collection(firestore, "api_users"), async snapshot => {
            let array = [];
            for (const element of snapshot.docs) {
                let transactionsArray = []
                let array1 = []
                if (element.data().customer_id) {
                    let transactions = await axios.get("https://appyard-server-1036279390366.asia-south1.run.app/getInvoices?customer_id=" + (element.data().customer_id ?? ""));
                    array1 = await transactions.data;

                    for (const element1 of array1.filter((element2) => element2.status === "paid")) {
                        transactionsArray.push({ ...element1, pdf: await generatePdf(element1, element.data()) })
                    }
                }

                array.push({
                    ...element.data(), transactions: transactionsArray, billedAmount: array1.filter((element1) => element1.status === "paid").reduce((sum, item) => {
                        return sum + (parseFloat(((item.amount / 100) / 0.9).toFixed(2)) || 0); // Adds the amount, or 0 if the amount is undefined
                    }, 0)
                });
            }
            setAllAdmin([...array])

            messageApi.destroy();
            messageApi.success("Loaded all the users.");
        })
    }

    async function generatePdf(element, user) {
        try {
            // Check if PDF already exists
            await getDownloadURL(ref(storage, `api_users/${element.notes?.uid ?? "F7gIIYHHXoh0TyjoGF4lLK0CN6d2"}/Invoices/${element.id}.pdf`));
            return `https://firebasestorage.googleapis.com/v0/b/appyard-e37d6.appspot.com/o/api_users%2F${element.notes?.uid ?? "F7gIIYHHXoh0TyjoGF4lLK0CN6d2"}%2FInvoices%2F${element.id}.pdf?alt=media`;
        } catch (error) {
            const gstCheck = "09";
            const isNoGst = user.gstType === "nogst" || user.gstType === "NOGST";

            // Use Firestore transaction to ensure unique invoice_count
            const counterRef = doc(firestore, "global", "counter");
            let invoiceId;
            await runTransaction(firestore, async (transaction) => {
                const counter = await transaction.get(counterRef);
                if (!counter.exists()) throw new Error("Counter document does not exist");

                if (isNoGst) {
                    // Use separate counter for NOGST users
                    const count = (counter.data().invoice_count_nogst ?? 0) + 1;
                    invoiceId = `AY25NO${String(count).padStart(3, '0')}`;
                    transaction.update(counterRef, { invoice_count_nogst: count });
                } else {
                    // Use regular counter for GST users
                    const count = (counter.data().invoice_count ?? 0) + 1;
                    invoiceId = `AY25${String(count).padStart(3, '0')}`;
                    transaction.update(counterRef, { invoice_count: count });
                }
            });
            let amount, gstAmount, gst;

            if (isNoGst) {
                // No GST applied for NOGST type
                amount = ((element.amount / 100) - (element.notes?.gst ?? 0)) / (user.tds ? 0.9 : 1);
                gstAmount = parseFloat(amount.toFixed(2));
                gst = 0;
            } else {
                // Regular GST calculation
                amount = (((element.amount / 100) - (element.notes?.gst ?? 0)) / (user.tds ? 0.9 : 1)) * 1.18;
                gstAmount = parseFloat((amount / 1.18).toFixed(2));
                gst = amount - gstAmount;
            }

            const body = {
                adjustHeightToFit: true,
                returnPdfInResponse: false,
                chromiumPdfOptions: { printBackground: true, format: "a5" },
                outputFileName: `${element.id}.pdf`,
                outputStoragePrefix: `api_users/${element.notes?.uid ?? "F7gIIYHHXoh0TyjoGF4lLK0CN6d2"}/Invoices`,
                outputStorageBucket: "appyard-e37d6.appspot.com",
                templatePath: "appyard-e37d6.appspot.com/templates/appyard-invoice.zip",
                data: {
                    invoiceId,
                    invoiceDate: dayjs(element.date * 1000).format("D MMM YYYY"),
                    usage: dayjs(new Date(element.date * 1000).setMonth(new Date(element.date * 1000).getMonth() - 1)).format("MMMM YYYY") + " Usage",
                    transactionId: element.payment_id,
                    name: user.name,
                    phone: user.phone,
                    email: user.contactEmail,
                    gst: isNoGst ? "N/A" : (user.gst || ""),
                    pos: isNoGst ? "N/A" : (user.pos || ""),
                    address: isNoGst ? "N/A" : (user.address || ""),
                    amount: gstAmount.toFixed(2),
                    totalAmount: amount.toFixed(2),
                    cgst: isNoGst ? "N/A" : (user.gst?.substring(0, 2) === gstCheck ? (gst / 2).toFixed(2) : "N/A"),
                    sgst: isNoGst ? "N/A" : (user.gst?.substring(0, 2) === gstCheck ? (gst / 2).toFixed(2) : "N/A"),
                    igst: isNoGst ? "N/A" : (user.gst?.substring(0, 2) === gstCheck ? "N/A" : gst.toFixed(2)),
                    paymentMethod: "Online"
                }
            };

            const response = await axios.post("https://appyard-server-1036279390366.asia-south1.run.app/generatePdf", body, {
                headers: { "Content-Type": "application/json" }
            });

            if (response.data.done !== "successful") throw new Error("PDF generation failed");

            // Update Firestore documents
            const userId = element.notes?.uid ?? "F7gIIYHHXoh0TyjoGF4lLK0CN6d2";
            await Promise.all([
                setDoc(doc(firestore, 'api_invoices', element.id), {
                    amount,
                    billingDate: dayjs(element.date * 1000).format("D MMM YYYY"),
                    companyGST: user.gst,
                    companyId: userId,
                    companyName: user.name,
                    invoice: invoiceId,
                    status: "Paid"
                }),
                setDoc(doc(firestore, `api_users/${userId}/invoices`, element.id), { invoice: invoiceId })
            ]);

            return `https://firebasestorage.googleapis.com/v0/b/appyard-e37d6.appspot.com/o/api_users%2F${userId}%2FInvoices%2F${element.id}.pdf?alt=media`;
        }
    }

    useEffect(() => {
        onAuthStateChanged(auth, (user) => {
            if (user) {
                onload();
            } else {
                window.location.href = "/login";
            }
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className='landing-container'>
            {contextHolder}
            <header>
                <h1>Api Users</h1>
                <div className='content-modes'>
                    Last Invoice (GST): {invoiceNumber} | Last Invoice (NOGST): {invoiceNumberNoGst}
                </div>
            </header>
            <Modal
                title="Change Password"
                open={open}
                okButtonProps={{
                    style: {
                        display: "none"
                    }
                }}
                onCancel={() => setOpen(false)}
                cancelText="Close"
            >
                <Space direction='vertical' style={{ width: '100%' }}>
                    <Input placeholder='Enter Password' value={allAdmin[selectedIndex]?.password} readOnly></Input>
                    <Input placeholder='Enter Password' value={allAdmin[selectedIndex]?.new_password} onChange={(event) => {
                        allAdmin[selectedIndex].new_password = event.target.value;
                        setAllAdmin([...allAdmin]);
                    }}></Input>
                    <Input placeholder='Confirm  Password' value={allAdmin[selectedIndex]?.new_confirm_password} onChange={(event) => {
                        allAdmin[selectedIndex].new_confirm_password = event.target.value;
                        setAllAdmin([...allAdmin]);
                    }}></Input>
                </Space>
            </Modal>
            <Modal
                title={`Details of ${allAdmin[selectedIndex]?.name}`}
                open={details}
                okButtonProps={{
                    style: {
                        display: "none"
                    }
                }}
                onCancel={() => setDetails(false)}
                cancelText="Close"
                width={"50%"}
                centered
            >
                <div className='details-container'>
                    <div className="input-container">
                        <label htmlFor="">Contact Email</label>
                        <Input placeholder='Enter Email' value={allAdmin[selectedIndex]?.contactEmail} onChange={(event) => {
                            allAdmin[selectedIndex].contactEmail = event.target.value;
                            setAllAdmin([...allAdmin]);
                        }} />
                    </div>
                    <div className="input-container">
                        <label htmlFor="">GST Type</label>
                        <Select
                            value={allAdmin[selectedIndex]?.gstType ?? "gst"}
                            placeholder="Select GST Type"
                            style={{ width: "100%" }}
                            onChange={(value) => {
                                allAdmin[selectedIndex].gstType = value;
                                setAllAdmin([...allAdmin]);
                            }}
                            options={[
                                { value: "gst", label: "GST" },
                                { value: "nogst", label: "NOGST" },
                            ]}
                        />
                    </div>
                    <div className="input-container">
                        <label htmlFor="">GST</label>
                        <Input
                            placeholder='Enter GST'
                            value={allAdmin[selectedIndex]?.gst}
                            onChange={(event) => {
                                allAdmin[selectedIndex].gst = event.target.value.toUpperCase();
                                setAllAdmin([...allAdmin]);
                            }}
                            disabled={allAdmin[selectedIndex]?.gstType === "nogst"}
                        />
                    </div>
                    {allAdmin[selectedIndex]?.gstType !== "nogst" && (
                        <>
                            <div className="input-container">
                                <label htmlFor="">Address</label>
                                <Input placeholder='Enter Address' value={allAdmin[selectedIndex]?.address} onChange={(event) => {
                                    allAdmin[selectedIndex].address = event.target.value;
                                    setAllAdmin([...allAdmin]);
                                }} />
                            </div>
                            <div className="input-container">
                                <label htmlFor="">Place Of Supply</label>
                                <Input placeholder='Enter POS' value={allAdmin[selectedIndex]?.pos} onChange={(event) => {
                                    allAdmin[selectedIndex].pos = event.target.value;
                                    setAllAdmin([...allAdmin]);
                                }} />
                            </div>
                        </>
                    )}
                    <div className="input-container">
                        <label htmlFor="">Billing Type</label>
                        <Select
                            value={allAdmin[selectedIndex]?.billingType ?? "dynamic"}
                            placeholder="Select Billing Type"
                            style={{ width: "100%" }}
                            onChange={(value) => {
                                allAdmin[selectedIndex].billingType = value;
                                setAllAdmin([...allAdmin]);
                            }}
                            options={[
                                { value: "fixed", label: "Fixed" },
                                { value: "dynamic", label: "Dynamic" },
                            ]}
                        />
                    </div>
                    <div className="input-container">
                        <label htmlFor="">API Billing</label>
                        <Select
                            value={allAdmin[selectedIndex]?.apiBilling ?? []}
                            placeholder="Select Option"
                            style={{ width: "100%" }}
                            onChange={(event) => {
                                allAdmin[selectedIndex].apiBilling = event;
                                setAllAdmin([...allAdmin]);
                            }}
                            options={[
                                { value: true, label: "Yes" },
                                { value: false, label: 'No' },
                            ]}
                        />
                    </div>
                    {allAdmin[selectedIndex]?.billingType !== "fixed" && (
                        <>
                            <div className="input-container">
                                <label htmlFor="">API Name</label>
                                <Input placeholder='Enter API Name' value={allAdmin[selectedIndex]?.api_name} onChange={(event) => {
                                    allAdmin[selectedIndex].api_name = event.target.value;
                                    setAllAdmin([...allAdmin]);
                                }} />
                            </div>
                            <div className="input-container">
                                <label htmlFor="">API Service</label>
                                <Input placeholder='Enter API' value={allAdmin[selectedIndex]?.api} onChange={(event) => {
                                    allAdmin[selectedIndex].api = event.target.value;
                                    setAllAdmin([...allAdmin]);
                                }} />
                            </div>
                            <div className="input-container">
                                <label htmlFor="">API Url</label>
                                <Input placeholder='Enter API Url' value={allAdmin[selectedIndex]?.api_url} onChange={(event) => {
                                    allAdmin[selectedIndex].api_url = event.target.value;
                                    setAllAdmin([...allAdmin]);
                                }} />
                            </div>
                        </>
                    )}
                    <div className="input-container">
                        <label htmlFor="">API Description</label>
                        <Input placeholder='Enter API Description' value={allAdmin[selectedIndex]?.api_description} onChange={(event) => {
                            allAdmin[selectedIndex].api_description = event.target.value;
                            setAllAdmin([...allAdmin]);
                        }} />
                    </div>
                    <div className="input-container">
                        <label htmlFor="">API Times</label>
                        <Input placeholder='Enter Times' value={allAdmin[selectedIndex]?.times} onChange={(event) => {
                            if (!isNaN(event.target.value)) {
                                allAdmin[selectedIndex].times = event.target.value;
                                setAllAdmin([...allAdmin]);
                            }
                        }} />
                    </div>
                    <div className="input-container">
                        <label htmlFor="">Cloud Times</label>
                        <Input placeholder='Enter Times' value={allAdmin[selectedIndex]?.cloud_times} onChange={(event) => {
                            if (!isNaN(event.target.value)) {
                                allAdmin[selectedIndex].cloud_times = event.target.value;
                                setAllAdmin([...allAdmin]);
                            }
                        }} />
                    </div>
                    <div className="input-container">
                        <label htmlFor="">Add On Times</label>
                        <Input placeholder='Enter Times' value={allAdmin[selectedIndex]?.addOn_times} onChange={(event) => {
                            if (!isNaN(event.target.value)) {
                                allAdmin[selectedIndex].addOn_times = event.target.value;
                                setAllAdmin([...allAdmin]);
                            }
                        }} />
                    </div>
                    <div className="input-container">
                        <label htmlFor="">Mail Service</label>
                        <Select
                            value={allAdmin[selectedIndex]?.mailService ?? []}
                            placeholder="Select Option"
                            style={{ width: "100%" }}
                            onChange={(event) => {
                                allAdmin[selectedIndex].mailService = event;
                                setAllAdmin([...allAdmin]);
                            }}
                            options={[
                                { value: true, label: "Yes" },
                                { value: false, label: 'No' },
                            ]}
                        />
                    </div>
                    <div className="input-container">
                        <label htmlFor="">TDS</label>
                        <Select
                            value={allAdmin[selectedIndex]?.tds ?? []}
                            placeholder="Select Option"
                            style={{ width: "100%" }}
                            onChange={(event) => {
                                allAdmin[selectedIndex].tds = event;
                                setAllAdmin([...allAdmin]);
                            }}
                            options={[
                                { value: true, label: "Yes" },
                                { value: false, label: 'No' },
                            ]}
                        />
                    </div>
                    <div className="input-container">
                        <label htmlFor="">CDN</label>
                        <Select
                            value={allAdmin[selectedIndex]?.cdn ?? []}
                            placeholder="Select Option"
                            style={{ width: "100%" }}
                            onChange={(event) => {
                                allAdmin[selectedIndex].cdn = event;
                                setAllAdmin([...allAdmin]);
                            }}
                            options={[
                                { value: true, label: "Yes" },
                                { value: false, label: 'No' },
                            ]}
                        />
                    </div>
                    <div className="input-container">
                        <label htmlFor="">Authentication</label>
                        <Select
                            value={allAdmin[selectedIndex]?.authentication ?? []}
                            placeholder="Select Option"
                            style={{ width: "100%" }}
                            onChange={(event) => {
                                allAdmin[selectedIndex].authentication = event;
                                setAllAdmin([...allAdmin]);
                            }}
                            options={[
                                { value: true, label: "Yes" },
                                { value: false, label: 'No' },
                            ]}
                        />
                    </div>
                    <div className="input-container">
                        <label htmlFor="">Total Billed Amount</label>
                        <Input placeholder='Enter Amount' value={allAdmin[selectedIndex]?.billedAmount} readOnly />
                    </div>
                    <div className='invoices-container'>
                        <div>Invoices</div>
                        <Space direction='vertical' style={{ width: "100%" }}>
                            {allAdmin[selectedIndex]?.transactions.map((element) => (
                                <div direction='horizontal' style={{ display: "flex", gap: "1rem", width: "100%" }}>
                                    <Input placeholder='Enter Usage' value={dayjs(new Date(element.date * 1000).setMonth(new Date(element.date * 1000).getMonth() - 1)).format("MMMM YYYY")} style={{ width: "100%" }} readOnly />
                                    <Input placeholder='Enter Status' value={element.status} style={{ width: "100%", textTransform: "capitalize" }} readOnly />
                                    <Button onClick={() => window.open(element.pdf)} disabled={!element.pdf} style={{ width: "100%" }}>Get Invoice</Button>
                                </div>
                            ))}
                        </Space>
                    </div>
                </div>
            </Modal>
            <form onSubmit={async (event) => {
                event.preventDefault();
                if (!object.image || object.image === "") {
                    messageApi.error("You need to upload image.");
                    return;
                }
                messageApi.loading("Adding User...", 0);
                let response = await fetch("https://appyard-server-1036279390366.asia-south1.run.app/admin/addUser", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        ...object,
                        image: object.image.name
                    })
                });
                let data = await response.json();
                if (data.text === "Successful") {
                    await uploadBytes(ref(storage, "api_users/" + data.uid + "/" + object.image.name), object.image);
                    setObject({});
                    messageApi.destroy();
                    messageApi.success("Added User.");
                } else {
                    messageApi.destroy();
                    messageApi.error(data.error);
                }
            }} className='main-add-container'>
                <Input placeholder='Display Name' value={object.displayName} onChange={(event) => {
                    setObject({ ...object, displayName: event.target.value });
                }} style={{ width: '160px' }} required></Input>
                <Input placeholder='User Name' value={object.name} onChange={(event) => {
                    setObject({ ...object, name: event.target.value });
                }} style={{ width: '160px' }} required></Input>
                <Input placeholder='User Phone' value={object.phone} addonBefore="+91" onChange={(event) => {
                    if (!isNaN(event.target.value)) {
                        setObject({ ...object, phone: event.target.value });
                    }
                }} style={{ width: '160px' }} minLength={10} maxLength={10} required></Input>
                <Input type='email' placeholder='Contact Email' value={object.contactEmail} onChange={(event) => {
                    setObject({ ...object, contactEmail: event.target.value });
                }} style={{ width: '160px' }} required></Input>
                <Select
                    value={object.gstType ?? "gst"}
                    placeholder="Select GST Type"
                    style={{ width: "160px" }}
                    onChange={(value) => {
                        setObject({ ...object, gstType: value });
                    }}
                    options={[
                        { value: "gst", label: "GST" },
                        { value: "nogst", label: "NOGST" },
                    ]}
                />
                <Input
                    placeholder='Company GST'
                    value={object.gst}
                    onChange={(event) => {
                        setObject({ ...object, gst: event.target.value.toUpperCase() });
                    }}
                    style={{ width: '160px' }}
                    disabled={object.gstType === "nogst"}
                    required={object.gstType !== "nogst"}
                ></Input>
                {object.gstType !== "nogst" && (
                    <>
                        <Input placeholder='Billing Address' value={object.address} onChange={(event) => {
                            setObject({ ...object, address: event.target.value });
                        }} style={{ width: '160px' }} required></Input>
                        <Input placeholder='Place of Supply' value={object.pos} onChange={(event) => {
                            setObject({ ...object, pos: event.target.value });
                        }} style={{ width: '160px' }} required></Input>
                    </>
                )}
                <Select
                    value={object.billingType ?? "dynamic"}
                    placeholder="Select Billing Type"
                    style={{ width: "160px" }}
                    onChange={(value) => {
                        setObject({ ...object, billingType: value });
                    }}
                    options={[
                        { value: "fixed", label: "Fixed" },
                        { value: "dynamic", label: "Dynamic" },
                    ]}
                />
                <Select
                    value={object.apiBilling ?? []}
                    placeholder="Select API Billing"
                    style={{ width: "160px" }}
                    onChange={(event) => {
                        setObject({ ...object, apiBilling: event });
                    }}
                    options={[
                        { value: true, label: "Yes" },
                        { value: false, label: 'No' },
                    ]}
                />
                {object.billingType !== "fixed" && (
                    <>
                        <Input placeholder='API Name' value={object.api_name} onChange={(event) => {
                            setObject({ ...object, api_name: event.target.value });
                        }} style={{ width: '160px' }} required></Input>
                        <Input placeholder='API' value={object.api} onChange={(event) => {
                            setObject({ ...object, api: event.target.value });
                        }} style={{ width: '160px' }} required></Input>
                        <Input placeholder='API Url' value={object.api_url} onChange={(event) => {
                            setObject({ ...object, api_url: event.target.value });
                        }} style={{ width: '160px' }} required></Input>
                    </>
                )}
                <Input placeholder='API Description' value={object.api_description} onChange={(event) => {
                    setObject({ ...object, api_description: event.target.value });
                }} style={{ width: '160px' }} required></Input>
                <Input placeholder='API Times' value={object.times} onChange={(event) => {
                    if (!isNaN(event.target.value)) {
                        setObject({ ...object, times: event.target.value });
                    }
                }} style={{ width: '160px' }} required></Input>
                <Input placeholder='Cloud Times' value={object.cloud_times} onChange={(event) => {
                    if (!isNaN(event.target.value)) {
                        setObject({ ...object, cloud_times: event.target.value });
                    }
                }} style={{ width: '160px' }} required></Input>
                <Input placeholder='AddOn Times' value={object.addOn_times} onChange={(event) => {
                    if (!isNaN(event.target.value)) {
                        setObject({ ...object, addOn_times: event.target.value });
                    }
                }} style={{ width: '160px' }} required></Input>
                <Select
                    value={object.mailService ?? []}
                    placeholder="Select Mail Service"
                    style={{ width: "160px" }}
                    onChange={(event) => {
                        setObject({ ...object, mailService: event });
                    }}
                    options={[
                        { value: true, label: "Yes" },
                        { value: false, label: 'No' },
                    ]}
                />
                <Select
                    value={object.tds ?? []}
                    placeholder="Select TDS"
                    style={{ width: "160px" }}
                    onChange={(event) => {
                        setObject({ ...object, tds: event });
                    }}
                    options={[
                        { value: true, label: "Yes" },
                        { value: false, label: 'No' },
                    ]}
                />
                <Select
                    value={object.cdn ?? []}
                    placeholder="Select CDN"
                    style={{ width: "160px" }}
                    onChange={(event) => {
                        setObject({ ...object, cdn: event });
                    }}
                    options={[
                        { value: true, label: "Yes" },
                        { value: false, label: 'No' },
                    ]}
                />
                <Select
                    value={object.authentication ?? []}
                    placeholder="Select Authentication"
                    style={{ width: "160px" }}
                    onChange={(event) => {
                        setObject({ ...object, authentication: event });
                    }}
                    options={[
                        { value: true, label: "Yes" },
                        { value: false, label: 'No' },
                    ]}
                />
                <Button onClick={() => document.getElementById("main_image").click()}>Upload Logo</Button>
                <input type="file" accept='image/*' name="main_image" id="main_image" onChange={(event) => {
                    setObject({ ...object, image: event.target.files[0] });
                }} style={{ display: "none" }} />
                <Input type='email' placeholder='User Email' value={object.email} onChange={(event) => {
                    setObject({ ...object, email: event.target.value });
                }} style={{ width: '160px' }} required></Input>
                <Input placeholder='User Password' value={object.password} onChange={(event) => {
                    setObject({ ...object, password: event.target.value });
                }} style={{ width: '160px' }} required></Input>
                <Button htmlType='submit'>Add User</Button>
            </form>
            <div className='products-display'>
                <div className='products-header'>
                    <div>Display Name</div>
                    <div>Name</div>
                    <div>Phone</div>
                    <div>Logo</div>
                    <div>Email</div>
                    <div>Password</div>
                    <div>Details</div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
                <div className='products-list'>
                    {allAdmin.map((element, index) => (
                        <form onSubmit={async (event) => {
                            event.preventDefault();
                            messageApi.loading("Saving User...", 0);

                            if ((element.new_password && element.new_password !== "" && element.new_password === element.new_confirm_password) || !element.new_password || element.new_password === "") {
                                let response = await fetch("https://appyard-server-1036279390366.asia-south1.run.app/admin/saveUser", {
                                    method: "POST",
                                    headers: {
                                        "Content-Type": "application/json"
                                    },
                                    body: JSON.stringify({
                                        ...element,
                                        password: element.new_password,
                                        image: element.image.name ? element.image.name : element.image
                                    })
                                });
                                let data = await response.json();
                                if (data.text === "Successful") {
                                    if (element.image.name) {
                                        await uploadBytes(ref(storage, "api_users/" + element.uid + "/" + element.image.name), element.image);
                                    }
                                    messageApi.destroy();
                                    messageApi.success("Saved User.");
                                } else {
                                    messageApi.destroy();
                                    messageApi.error(data.error);
                                }
                            } else if (element.new_password && element.new_password !== element.new_confirm_password) {
                                messageApi.destroy();
                                messageApi.error("Password Mismatch.");
                            }
                        }} className='product'>
                            <Input placeholder='Display Name' value={element.displayName} onChange={(event) => {
                                element.displayName = event.target.value;
                                setAllAdmin([...allAdmin]);
                            }} style={{ width: '160px' }} required></Input>
                            <Input placeholder='User Name' value={element.name} onChange={(event) => {
                                element.name = event.target.value;
                                setAllAdmin([...allAdmin]);
                            }} style={{ width: '160px' }} required></Input>
                            <Input placeholder='User Phone' value={element.phone} addonBefore="+91" onChange={(event) => {
                                if (!isNaN(event.target.value)) {
                                    element.phone = event.target.value;
                                    setAllAdmin([...allAdmin]);
                                }
                            }} style={{ width: '160px' }} minLength={10} maxLength={10} required></Input>
                            <Button onClick={() => document.getElementById("change_image_" + index).click()}>Change Image</Button>
                            <input type="file" accept='image/*' name="change_image" id={"change_image_" + index} onChange={(event) => {
                                element.image = event.target.files[0];
                                setAllAdmin([...allAdmin]);
                            }} style={{ display: "none" }} />
                            <Input type='email' placeholder='User Email' value={element.email} onChange={(event) => {
                                element.email = event.target.value;
                                setAllAdmin([...allAdmin]);
                            }} style={{ width: '160px' }} required></Input>
                            <Button onClick={() => {
                                setSelectedIndex(index);
                                setOpen(true)
                            }}>Change Password</Button>
                            <Button onClick={() => {
                                setDetails(true);
                                setSelectedIndex(index);
                            }}>Open Details</Button>
                            <Button htmlType='submit'>Save User</Button>
                            <Popconfirm
                                title="Are you sure you want to delete the admin ?"
                                onConfirm={async () => {
                                    messageApi.loading("Deleting User...", 0);

                                    await fetch("https://appyard-server-1036279390366.asia-south1.run.app/admin/deleteUser", {
                                        method: "POST",
                                        headers: {
                                            "Content-Type": "application/json"
                                        },
                                        body: JSON.stringify({
                                            uid: element.uid
                                        })
                                    });

                                    messageApi.destroy();
                                    messageApi.success("Deleted User.");
                                }}
                            >
                                <Button danger>Delete User</Button>
                            </Popconfirm>
                            <Button onClick={() => {
                                messageApi.loading("Sending Email...");
                                emailjs.send('service_xnecgg9', 'template_dqy8a35', {
                                    date: dayjs().format("D MMM YYYY, h:mm:ss A"),
                                    name: element.name,
                                    loginEmail: element.email,
                                    loginPass: element.password,
                                    contactEmail: element.contactEmail
                                }, 'vZ7JaexErbLF7vqET')
                                    .then((result) => {
                                        messageApi.destroy();
                                        messageApi.success("Successfully sent the email.");
                                    }, (error) => {
                                        messageApi.destroy();
                                        messageApi.error("Error sending the email.");
                                    });
                            }}>Send Email</Button>
                        </form>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default Admin
